var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.009 0.164428C11.8724 0.0578733 11.7042 0 11.531 0C11.3578 0 11.1896 0.0578733 11.053 0.164428L0 8.78443L0.956 9.99343L2.308 8.93943V18.4614C2.30879 18.8692 2.47105 19.26 2.75928 19.5484C3.04751 19.8369 3.43825 19.9994 3.846 20.0004H19.231C19.6387 19.9996 20.0294 19.8373 20.3177 19.5491C20.6059 19.2608 20.7682 18.8701 20.769 18.4624V8.94643L22.121 10.0004L23.077 8.79143L12.009 0.164428ZM13.076 18.4644H10V12.3084H13.077L13.076 18.4644ZM14.614 18.4644V12.3084C14.6135 11.9007 14.4513 11.5098 14.1629 11.2215C13.8746 10.9332 13.4837 10.771 13.076 10.7704H10C9.59226 10.771 9.20137 10.9332 8.91305 11.2215C8.62474 11.5098 8.46253 11.9007 8.462 12.3084V18.4624H3.846V7.74043L11.538 1.74843L19.23 7.74843V18.4624L14.614 18.4644Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.74d9c3ca0d96e2d5ffc89601349063b6.svg";
export { ForwardRef as ReactComponent };